@if(content){
<!-- close button -->
<button class="pos-absolute top-3 right-3 bottom-0 flex"
        [style.height]="'fit-content'"
        type="button"
        [attr.aria-label]="'Close' | translate"
        (click)="close()">
    <i class="icon-close"
       [style.line-height.px]="0"
       aria-hidden="true"></i>
</button>

<div class="bg-col-w p-t-5 p-b-5 p-l-8 p-r-8 flex flex-column flex-middle">
    @switch (modalData.variant || content.variantPreview) {
    @case ('canCarry') {
    <p class="h3 center m-b-2 m-b-4-s"
       *iCms="'title' of content; content: 'html'">
    </p>
    <p class="p2 center m-t-4"
       *iCms="'subtitle' of content; content: 'html'"></p>
    <button class="w-12 button m-t-5"
            (click)="accept()"
            type="button"
            [attr.aria-label]="'Accept' | translate">
        <span>{{"Yes" | translate}}</span>
    </button>
    <div class="w-12 flex flex-justify-center m-t-5">
        <a class="button-inline-2"
           type="button"
           [attr.href]="getRedirectLink(modalData.siteId)"
           [attr.aria-label]="'Do nothing' | translate">
            <span>{{"No, do nothing" | translate}}</span>
        </a>
    </div>
    }
    @case ('cannotCarry') {
    <p class="h3 center m-b-2 m-b-4-s"
       *iCms="'infoTitle' of content; content: 'html'">
    </p>
    <p class="p2 center m-t-4"
       *iCms="'infoSubtitle' of content; content: 'html'"></p>
    <button class="w-12 button m-t-5"
            type="button"
            (click)="close()"
            [attr.aria-label]="'Dismiss' | translate">
        <span>{{"Dismiss" | translate}}</span>
    </button>
    }
    @case ('error') {
    <p class="h3 center m-b-2 m-b-4-s"
       *iCms="'errorTitle' of content; content: 'html'">
    </p>
    @if (!modalData.errorMessage) {
    <p class="p2 center m-t-4"
       *iCms="'errorSubtitle' of content; content: 'html'"></p>
    }
    @if (modalData.errorMessage) {
    <p class="p2 center m-t-4"> {{modalData.errorMessage | translate}}</p>
    }
    }
    }
</div>
}